<script>
    import { getContext } from "svelte";
    import { key } from "../context/cinemaTileDimension";
    import { key as add2BasketButtonCtxKey, supportedColors as add2BasketButtonColors, ButtonColor } from "../context/add2BasketButton.js";
    import Add2BasketButton from "./Add2BasketButton.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        brandName,
        variation,
        pricing,
        showTopInfo = false,
        widgetAdditionalClickTracking,
        additionalClickTracking,
        add2BasketVisibleTrack,
    } = $props();

    const add2BasketButton = getContext(add2BasketButtonCtxKey);

    const tileDimensions = getContext(key);
</script>

<div style:width={`${tileDimensions.width}px`} class="reco_cinema__information-container">
    <div class="reco_cinema__brand oc-copy-75">
        {brandName}
    </div>
    <div class="reco_cinema__name oc-copy-100">
        {variation.name}
    </div>
    {#if add2BasketButtonColors.includes(add2BasketButton?.buttonColor)}
        <div class="oc-mt-50 oc-mb-50">
            <Add2BasketButton
                variationId={variation.id}
                {widgetAdditionalClickTracking}
                {additionalClickTracking}
                isRedVariant={add2BasketButton?.buttonColor === ButtonColor.RED}
                {add2BasketVisibleTrack}
            />
        </div>
    {/if}
    {#if showTopInfo && variation.topInfo}
        <div class="reco_cinema__top-info oc-copy-100">
            <strong>{variation.topInfo}</strong>
        </div>
    {/if}
    <div class="reco_cinema__original-price">
        {#if pricing.originalPricePrefix}
            <span class="reco_cinema__uvp-string oc-copy-100" role="tabpanel">
                {pricing.originalPricePrefix}
            </span>
        {/if}
        {#if pricing.originalPrice}
            <span class="reco_cinema__nowrap reco_cinema__price-line-through oc-copy-100" role="tabpanel">
                {pricing.originalPrice}
            </span>
        {/if}
    </div>
    {#if !variation.highlightText && !pricing.retailPricePrefix}
        <span
            class="reco_cinema__retail-price reco_cinema__nowrap oc-headline-50"
            class:reco_cinema__price-red={pricing.originalPrice}
            role="tabpanel">{pricing.retailPrice}</span
        >
    {/if}
    {#if variation.highlightText || pricing.retailPricePrefix}
        <span
            class="oc-headline-50 reco_cinema__retail-price reco_cinema__price-spacing"
            class:reco_cinema__price-red={pricing.originalPrice}
            role="tabpanel"
        >
            {#if pricing.retailPricePrefix}{pricing.retailPricePrefix}{/if}
            <span class="reco_cinema__nowrap" class:reco_cinema__price-red={pricing.originalPrice} role="tabpanel"
                >{pricing.retailPrice}</span
            >
            {#if variation.highlightText}<div class="oc-pt-25 reco_cinema__highlight-text">
                    {variation.highlightText}
                </div>{/if}
        </span>
    {/if}

    {#if pricing.unitPrice}
        <div class="reco_cinema__price-per-unit oc-headline-10">
            <span role="tabpanel"> {pricing.unitPrice} </span>
        </div>
    {/if}
</div>

<style lang="scss">
    :root {
        --padding_within_cell: 8px;
    }

    .reco_cinema__brand {
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__information-container {
        text-align: left;
        overflow: hidden;
        max-width: 100%;
        margin-top: 8px;
    }

    .reco_cinema__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__top-info {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__original-price {
        margin-top: 8px;
    }

    .reco_cinema__nowrap {
        white-space: nowrap;
    }

    .reco_cinema__uvp-string {
        padding-right: var(--padding_within_cell);
    }

    .reco_cinema__retail-price {
        display: inline-block;
    }

    .reco_cinema__price-line-through {
        padding-right: var(--padding_within_cell);
        text-decoration: line-through;
    }

    .reco_cinema__price-red {
        color: var(--oc-semantic-color-brand);
    }

    .reco_cinema__price-per-unit {
        padding: 6px 4px 6px 4px;
        color: var(--oc-semantic-color-text-secondary);
    }

    .reco_cinema__price-spacing {
        padding-top: 2px;
    }

    .reco_cinema__highlight-text {
        line-height: calc(1em + 10px);
        margin-top: -2px;
    }
</style>
